import React, {ChangeEvent} from 'react';
import styles from './Input.module.css'
import clsx from "clsx";

interface IProps {
    type: string,
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
    placeholder?: string,
    className?: string | string[],
    defaultValue?: string | number,
    id?: string | number
}

const Input = ({type, onChange, placeholder = '', className, defaultValue = ''}: IProps) => {
    return <input
        defaultValue={defaultValue}
        className={clsx(className && className, styles.input)}
        type={type}
        placeholder={placeholder}
        onChange={(e) => onChange ? onChange(e) : {}}/>
};

export default Input;